import {useInitialUtmParams, useQueryParams} from '@aboutyou/router';
import {AdjustTracker} from '@aboutyou/tracking';

export const BASE_STORE_LINK = 'https://aboutyouapp.go.link';

export type AdjustDeepLinkType = AdjustDeepLink | string;
export enum AdjustDeepLink {
  CouponWallet = '/cw',
}

const adjustParamMap = {
  adj_campaign: 'utm_medium',
  adj_adgroup: 'utm_source',
  adj_creative: 'utm_campaign',
} as const;

export const useGetStoreLink = ({
  adjustTracker,
  deepLink,
}: {
  adjustTracker: AdjustTracker;
  deepLink: AdjustDeepLinkType;
}) => {
  const search = useQueryParams({includeUtmParams: true});
  const utmParams = useInitialUtmParams();

  const url = new URL(`${BASE_STORE_LINK}${deepLink}`);
  const urlParams = new URLSearchParams(search);
  urlParams.append('adjust_t', adjustTracker);

  // append utm params
  for (const [key, value] of utmParams) {
    if (!urlParams.get(key)) {
      urlParams.append(key, value);
    }
  }

  // map utm params
  for (const [key, equivalentKey] of Object.entries(adjustParamMap)) {
    const value = utmParams.get(equivalentKey);
    if (value) {
      urlParams.append(key, value);
    }
  }

  url.search = urlParams.toString();

  return url.toString();
};
